var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.875C8.31066 6.875 8.5625 7.12684 8.5625 7.4375V10.8125C8.5625 11.1232 8.31066 11.375 8 11.375C7.68934 11.375 7.4375 11.1232 7.4375 10.8125V7.4375C7.4375 7.12684 7.68934 6.875 8 6.875ZM8.00001 6.0302C8.4654 6.0302 8.84268 5.65293 8.84268 5.18753C8.84268 4.72214 8.4654 4.34487 8.00001 4.34487C7.53462 4.34487 7.15735 4.72214 7.15735 5.18753C7.15735 5.65293 7.53462 6.0302 8.00001 6.0302ZM1.25 8C1.25 4.27208 4.27208 1.25 8 1.25C11.7279 1.25 14.75 4.27208 14.75 8C14.75 11.7279 11.7279 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8ZM8 2.375C4.8934 2.375 2.375 4.8934 2.375 8C2.375 11.1066 4.8934 13.625 8 13.625C11.1066 13.625 13.625 11.1066 13.625 8C13.625 4.8934 11.1066 2.375 8 2.375Z",
    fill: "#0968E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileInfo);
export default __webpack_public_path__ + "static/media/mobile-info.ff094033ad4821962e0b0350bb743071.svg";
export { ForwardRef as ReactComponent };